﻿window.isue_meterpollschedulehours = function () {
    var instance = {
        init: function (args) {
            var table = document.getElementById(args.clientID);
            var radio = document.getElementById(args.radioInputID + "_placeholder");
            table.querySelectorAll("td[r][c]").forEach(el => {
                el.addEventListener("mouseup", function (evt) {
                    radio.querySelectorAll("input").forEach(el => { el.checked = false; })
                    radio.querySelector("input[value='arbitrarytime']").checked = true;
                    return false;
                });
            });
            radio.querySelector("input[value='banalltime']").addEventListener("change", function () {
                fillValues(table, args.inputID, "off");
            });
            radio.querySelector("input[value='allowalltime']").addEventListener("change", function () {
                fillValues(table, args.inputID, "on");
            });
        }
    };
    function fillValues(table, inputID, value) {
        table.querySelectorAll("td[r][c]").forEach(el => {
            el.classList.remove("on");
            el.classList.remove("off");            
            el.classList.add(value);
            el.setAttribute("value", value);
        });
        window.grideditor.fillInput(table, inputID);
    }
    return instance;
}();